import { Injectable } from '@angular/core';
import { SecureHttp } from '@app/security/secure-http';
import { T2EKeyword } from '@app/t2e-mgmt/types/t2e-keyword';
import { baseEnv } from '@env/base-env';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class T2eService {
  constructor(private http: SecureHttp) {}

  getAllKeywordsByShortcode(
    clientId: string,
    shortcode: string,
  ): Observable<T2EKeyword[]> {
    const url = `${baseEnv.portalURLBase}/client/${clientId}/t2e/keywords/${shortcode}`;
    return this.http.get(url);
  }

  addKeyword(
    clientId: string,
    shortcode: string,
    keyword: Omit<T2EKeyword, 'created_at' | 'updated_at' | 'clientId'>,
  ): Observable<T2EKeyword[]> {
    const url = `${baseEnv.portalURLBase}/client/${clientId}/t2e/keywords/${shortcode}`;
    return this.http.post(url, keyword);
  }

  updateKeyword(
    clientId: string,
    shortcode: string,
    keywordToUpdate: string,
    updatedKeyword: Omit<T2EKeyword, 'created_at' | 'updated_at' | 'clientId'>,
  ): Observable<T2EKeyword[]> {
    const url = `${baseEnv.portalURLBase}/client/${clientId}/t2e/keywords/${shortcode}/${keywordToUpdate}`;
    return this.http.put(url, updatedKeyword);
  }

  deleteKeyword(
    clientId: string,
    shortcode: string,
    keyword: string,
  ): Observable<T2EKeyword[]> {
    const url = `${baseEnv.portalURLBase}/client/${clientId}/t2e/keywords/${shortcode}/${keyword}`;
    return this.http.delete(url);
  }
}
